import {
  // Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  createBrowserRouter,
  Link,
  // Navigate,
  Outlet,
  RouterProvider,
  ScrollRestoration,
  useLocation,
} from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
// import { Collapse } from "@material-tailwind/react";
// import Switch from "react-switch";
// import { Dialog, Transition } from "@headlessui/react";
// import FlyySDK from "flyy-web-sdk";
// import { flyy_partner_id, sdkWrapperURL } from "./utils/api-url-list";
import AuthProvider, { useAuth } from "./utils/auth";

import UserIcon from "./assets/images/user-icon.png";
// import Logo from "./assets/images/e&enterprise_logo_white.png";
// import Dimond from "./assets/images/Dimond.svg";
// import Coins from "./assets/images/coin.svg";
// import GoogleFit from "./assets/icons/google-fit-icon.svg";
// import DeviceIcon from "./assets/icons/smartphone-2-svgrepo-com.svg";
// import { ReactComponent as Menu } from "./assets/icons/Menu.svg";
// import { ReactComponent as Close } from "./assets/icons/Close.svg";
// import { ReactComponent as DashboardIcon } from "./assets/icons/Dashboard.svg";
// import { ReactComponent as MyAccountIcon } from "./assets/icons/MyAccount.svg";
// import { ReactComponent as TutorialIcon } from "./assets/icons/Tutorial.svg";
// import { ReactComponent as SupportIcon } from "./assets/icons/Support.svg";
// import { ReactComponent as LogoutIcon } from "./assets/icons/Logout.svg";
// import Tab3 from "./assets/images/tab-icon3.svg";
// import { ReactComponent as Rotate } from "./assets/icons/Rotate.svg";

import Login from "./screens/Login";
import TermsOfUSe from "./screens/TermsOfUse";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import BasicDetails from "./screens/BasicDetails";
import MyAccount from "./screens/MyAccount";
import Tutorial from "./screens/Tutorial";
import Support from "./screens/Support";
import Dashboard from "./screens/Dashboard";
import StartScan from "./screens/StartScan";
import SelectScanOption from "./screens/SelectScanOption";
// import SelectOption from "./screens/SelectOption";
import AllScanInstructions from "./screens/AllScanInstructions";
import ScanInstructions from "./screens/ScanInstructions";
import CameraPermissionGuide from "./screens/CameraPermissionGuide";
// import SelectPosture from "./screens/SelectPosture";
import AllCombinedFaceScan from "./screens/AllCombinedFaceScan";
import AllCombinedResult from "./screens/AllCombinedResult";
import FaceScan from "./screens/FaceScan";
import FingerScan from "./screens/FingerScan";
import ScanResult from "./screens/ScanResult";
import Survey from "./screens/Survey";
import HeartHealth from "./screens/history/HeartHealth";
import BodyVitals from "./screens/history/BodyVitals";
import PhysioFitness from "./screens/history/PhysioFitness";
import StressIndex from "./screens/history/StressIndex";
import DetailHistory from "./screens/history/DetailHistory";
import Abha from "./screens/Abha";
import LabPackages from "./screens/LabPackages";
import DoctorList from "./screens/DoctorList";
import DoctorAppointment from "./screens/DoctorAppointment";
import Education from "./screens/Education";
import EducationDetails from "./screens/EducationDetails";
import WellnessProgram from "./screens/WellnessProgram";
import JoinProgram from "./screens/JoinProgram";
import Medication from "./screens/Medication";
import Nutrition from "./screens/Nutrition";
import Activity from "./screens/Activity";
import Walking from "./screens/Walking";
import WalkingDetails from "./screens/WalkingDetails";
import BMI from "./screens/BMI";
import MentalWellbing from "./screens/MentalWellbing";
import DailyWellbing from "./screens/DailyWellbing";
import WellbingDetails from "./screens/WellbingDetails";
import HealthHabbits from "./screens/HealthHabbits";
import HealthDetails from "./screens/HealthDetails";
import Reward from "./screens/Reward";
import LiveChat from "./screens/LiveChat";
import VitalsIndex from "./screens/VitalsIndex";
import DiabetesInsights from "./screens/DiabetesInsights";
import HeartHealthScore from "./screens/HeartHealthScore";
import MyCare from "./screens/MyCare";
// import BreathLab from "./screens/BreathLab";
import PackageList from "./screens/PackageList";
import PackageDetails from "./screens/PackageDetails";
import InsuranceList from "./screens/InsuranceList";
import MoodTracking from "./screens/MoodTracking";
// import TrakingSuccess from "./screens/TrakingSuccess";
// import ProgramTracking from "./screens/ProgramTracking";
// import BackPain from "./screens/BackPain";
// import PeriodCramps from "./screens/PeriodCramps";
// import MigrainePain from "./screens/MigrainePain";
// import AnalysisData from "./screens/AnalysisData";
import ScoreHistory from "./screens/ScoreHistory";
// import Headache from "./screens/Headache";
// import ShoulderPain from "./screens/ShoulderPain";
// import KneePain from "./screens/KneePain";
import MyHealth from "./screens/MyHealth";
import LabPackageDetail from "./screens/LabPackageDetail";
import DiscountCenter from "./screens/DiscountCenter";
import BmiHistory from "./screens/BmiHistory";
import MyMind from "./screens/MyMind";
import VitalsScore from "./screens/VitalsScore";
import HealthChallenge from "./screens/HealthChallenge";
import MoodInsight from "./screens/MoodInsight";
import MoodHistory from "./screens/MoodHistory";
import BetterSleep from "./screens/BetterSleep";
import BedtimeStory from "./screens/BedtimeStory";
import BedtimeMelody from "./screens/BedtimeMelody";
import RelaxingMusic from "./screens/RelaxingMusic";
import NutritionPackage from "./screens/NutritionPackage";
import BedtimeStretching from "./screens/BedtimeStretching";
import Wellbeing from "./screens/Wellbeing";
// import SelfCare from "./screens/SelfCare";
// import ManagingStress from "./screens/ManagingStress";
// import PersonalGrowth from "./screens/PersonalGrowth";
// import IncreasingWorkLife from "./screens/IncreasingWorkLife";
// import EmotionalResilience from "./screens/EmotionalResilience";
import RelaxationMusic from "./screens/RelaxationMusic";
import YogaMeditation from "./screens/YogaMeditation";
import VisualizationTranquility from "./screens/VisualizationTranquility";
import WellbeingContentDetails from "./screens/WellbeingContentDetails";
import ContentDetails from "./screens/ContentDetails";
import ContentTabs from "./screens/ContentTabs";
import NutritionPackageList from "./screens/NutritionPackageList";
import MindfulMoments from "./screens/MindfulMoments";
import FitnessPackage from "./screens/FitnessPackage";
import OurPricing from "./screens/OurPricing";
import MoodtrackStep from "./screens/MoodtrackStep";
import MyProfile from "./screens/MyProfile";
import InsurancePolicy from "./screens/InsurancePolicy";
import RelivePain from "./screens/RelivePain";
import NutrationList from "./screens/NutrationList";
import DYKList from "./screens/DYKList";
import DYKDetails from "./screens/DYKDetails";
import ConfigureAlerts from "./screens/ConfigureAlerts";
import SelectUserAlert from "./screens/SelectUserAlert";
import AlertSetting from "./screens/AlertSetting";
import SelectUser from "./screens/SelectUser";
import DiagnosticPackages from "./screens/DiagnosticPackages";
import RequestCallback from "./screens/RequestCallback";
import DigitalClinic from "./screens/DigitalClinic";
import Goal from "./screens/Goal";
import AddGoal from "./screens/AddGoal";
import SelectedGoal from "./screens/SelectedGoal";
import CognitiveScore from "./screens/CognitiveScore";
import CognitiveAssessments from "./screens/CognitiveAssessments";
import SimonTest from "./screens/SimonTest";
import SimonTestCircle from "./screens/SimonTestCircle";
import SimonScore from "./screens/SimonScore";
import ScoreDetails from "./screens/ScoreDetails";
import NutritionResults from "./screens/NutritionResults";
import NutritionReceipesList from "./screens/NutritionReceipesList";
import NutritinReceipeDetail from "./screens/NutritionReceipeDetail";
import WaterTracker from "./screens/WaterTracker";
import DownloadAPP from "./screens/Download";
import NotFound from "./screens/404";
import Referal from "./screens/Referal";
import NutrationHistory from "./screens/NutrationHistory";
import Vouchers from "./screens/Vouchers";
import DoctorConsultation from "./screens/DoctorConsultation";
import UnityScore from "./screens/UnityScore";
import Assessments from "./screens/Assessments";
import AllergyDashboard from "./screens/AllergyDashboard";
import NewAssessment from "./screens/NewAssessment";
import AssessmentResult from "./screens/AssessmentResult";
import PulmoDashboard from "./screens/PulmoDashboard";
import FingerScanInstructions from "./screens/FingerScanInstructions";
import VoiceAudiSample from "./screens/VoiceAudiSample";
import CoughAudiSample from "./screens/CoughAudiSample";
import PulmoSurvey from "./screens/PulmoSurvey";
import PulmonaryResult from "./screens/PulmoResult";
import VisionInstructions from "./screens/VisionInstructions";
import VisionFaceScan from "./screens/VisionFaceScan";
import VisionResult from "./screens/VisionResult";
import VisionSurvey from "./screens/VisionSurvey";
import DermaStart from "./screens/DermaStart";
import SkinAnalyzer from "./screens/SkinAnalyzer";
import DermaResult from "./screens/DermaResult";
import PulmoFingerScan from "./screens/PulmoFingerScan";
import PulmoFingerScanInstruction from "./screens/PulmoFingerScanInstruction";
import DentalStart from "./screens/DentalStart";
import CaptureType from "./screens/CaptureType";
import DentalAnalyzer from "./screens/DentalAnalyzer";
import AssistantInstructions from "./screens/AssistantInstructions";
import DentalScanResult from "./screens/DentalScanResult";
import DentalScanHistory from "./screens/DentalScanHistory";
import EventGetStarted from "./screens/EventGetStarted";
import BMIPhotoCapture from "./screens/BMIPhotoCapture";
import BMIResultEdit from "./screens/BMIScanResult";
import PulmoFaceScan from "./screens/PulmoFaceScan";
import PulmoFaceScanInstruction from "./screens/PulmoFaceScanInstruction";
import CardiovascularObservationResult from "./screens/CardiovascularObservationResult";
import DigitalHealthScreen from "./screens/DigitalHealthScreening";
import AllScanDashboard from "./screens/AllScanDashboard";
import SelectAssessments from "./screens/SelectAssessments";
import UploadDocuments from "./screens/UploadDocuments";
import ConfigureAssessments from "./screens/ConfigureAssessments";
import DigiMerAssesment from "./screens/DigiMerAssesment";
import VitalsDermaFaceScan from "./screens/DermaAllergy/VitalsDermaFaceScan";
import VitalsDerma from "./screens/DermaAllergy/VitalsDerma";
import VitalsScanInstructions from "./screens/DermaAllergy/VitalsScanInstructions";

const Header = () => {
  // const { pathname } = useLocation();
  const {
    // getToken,
    // logout,
    userData: {
      fname,
      // profile_id,
      // flyy_id
    },
  } = useAuth();
  // const [isOpen, setIsOpen] = useState(false);
  const greetingsText = useMemo(() => {
    const hourNow = new Date().getHours();
    return hourNow < 12
      ? "Good Morning"
      : hourNow < 17
      ? "Good Afternoon"
      : "Good Evening";
  }, []);

  // const viewRewards = () => {
  //   if (typeof window?.ReactNativeWebView?.postMessage === "function")
  //     window.ReactNativeWebView.postMessage(
  //       JSON.stringify({ event: "view-rewards", data: { userID: flyy_id } })
  //     );
  //   else {
  //     window.flyySDK?.openRewardsScreen({ fullScreen: true });
  //   }
  // };

  // const [open, setOpen] = useState(false);
  // const toggleOpen = () => setOpen((cur) => !cur);
  // const [active, setActive] = useState(false);
  // const [balance, setBalance] = useState(-1);

  // function handleChange(checked) {
  //   setActive(checked);
  // }

  // useEffect(() => {
  // (async () => {
  //   try {
  //     const token = await getToken();
  //     const flyySDK = new FlyySDK();
  //     const flyyTokenResp = await fetch(sdkWrapperURL("/flyy/user-token"), {
  //       method: "POST",
  //       headers: { "content-type": "application/json", Authorization: token },
  //       body: JSON.stringify({ profile_id }),
  //     });
  //     const flyyTokenRespJSON = await flyyTokenResp.json();
  //     if (flyyTokenRespJSON?.statusCode?.toString().startsWith("2")) {
  //       flyySDK.init(
  //         JSON.stringify({
  //           package_name: "com.careplix.one",
  //           partner_id: flyy_partner_id,
  //           ext_user_token: flyyTokenRespJSON.user_token,
  //           attachMode: "popup",
  //           // attachMode: "drawer",
  //           // attachMode: "fullscreen",
  //           environment: "STAGING",
  //         })
  //       );
  //       window.flyySDK = flyySDK;
  //     } else
  //       throw new Error(
  //         flyyTokenRespJSON.message ?? "Error in Fetching data"
  //       );
  //   } catch (err) {
  //     console.error(err);
  //   }
  // })();
  // (async () => {
  //   try {
  //     const token = await getToken();
  //     const walletCoins = await fetch(sdkWrapperURL("/flyy/get-balance"), {
  //       method: "POST",
  //       headers: { "content-type": "application/json", Authorization: token },
  //       body: JSON.stringify({}),
  //     });
  //     const res = await walletCoins.json();
  //     if (res?.statusCode?.toString().startsWith("2")) setBalance(res.coins);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // })();
  // }, [getToken, profile_id]);
  const [activeLink, setActiveLink] = useState("/");

  const handleClick = (path) => {
    setActiveLink(path);
  };
  return (
    <main className="min-h-screen relative bg-primary text-white ">
      {/* <Transition show={isOpen} as={Fragment}>
        <Dialog as={Fragment} onClose={() => setIsOpen(false)}>
          <Transition.Child
            className="fixed inset-0 bg-white/50"
            enter="duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="duration-300 delay-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Transition.Child
              as={Fragment}
              enter="delay-150 duration-200 transition-transform transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="duration-200 transition-transform transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel
                as="aside"
                className="min-h-full w-64 bg-white flex flex-col items-stretch"
              >
                <div className="flex items-start justify-between p-6">
                  <div className="w-40 text-white">
                    <Dialog.Title as="h3" className="text-sm">
                      {greetingsText}
                    </Dialog.Title>
                    <Dialog.Title
                      as="h2"
                      className="text-lg font-medium truncate"
                    >
                      {fname}
                    </Dialog.Title>
                  </div>
                  <button
                    className="flex-shrink-0 bg-primary p-1.5 rounded-full"
                    type="button"
                    onClick={() => setIsOpen(false)}
                  >
                    <Close className="h-5 w-5 text-white" />
                  </button>
                </div>
                <nav className="mt-4">
                  <ul className="space-y-4">
                    {[
                      {
                        to: "/",
                        label: "Dashboard",
                        icon: (
                          <DashboardIcon className="h-5 w-5 text-primary" />
                        ),
                      },
                      {
                        to: "/my-account",
                        label: "My Account",
                        icon: (
                          <MyAccountIcon className="h-5 w-5 text-primary" />
                        ),
                      },
                      {
                        to: "/tutorial",
                        label: "Tutorial",
                        icon: <TutorialIcon className="h-5 w-5 text-primary" />,
                      },
                      {
                        to: "/support",
                        label: "Support",
                        icon: <SupportIcon className="h-5 w-5 text-primary" />,
                      },
                    ].map((linkObj) => (
                      <li key={linkObj.to} className="pr-6">
                        <Link
                          to={linkObj.to}
                          className={`flex items-center space-x-4 py-2 px-6 rounded-r-full ${
                            pathname === linkObj.to
                              ? "bg-secondary/10"
                              : "bg-transparent"
                          } hover:bg-secondary/5`}
                          onClick={() => setIsOpen(false)}
                        >
                          {linkObj.icon}
                          <span className="text-primary text-xs">
                            {linkObj.label}
                          </span>
                        </Link>
                      </li>
                    ))}
                    <li className="flex flex-col">
                      <Link
                        to=""
                        className="flex items-center py-2 px-6 rounded-r-full"
                        onClick={toggleOpen}
                      >
                        <img
                          src={DeviceIcon}
                          width="20"
                          className="mr-5"
                          alt=""
                        />
                        <span className="text-primary text-xs">
                          {" "}
                          Connected Device
                        </span>
                      </Link>
                      <Collapse open={open}>
                        <div className="flex justify-between px-6 py-1">
                          {" "}
                          <p className="text-white text-xs pl-10 flex items-center">
                            <img
                              src={GoogleFit}
                              alt=""
                              width="10"
                              className="mr-3"
                            />{" "}
                            Google Fit
                          </p>{" "}
                          <Switch
                            onColor="#86d3ff"
                            onHandleColor="#2693e6"
                            handleDiameter={14}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            onChange={handleChange}
                            checkedIcon={false}
                            uncheckedIcon={false}
                            checked={active}
                            height={10}
                            width={25}
                          />
                        </div>
                      </Collapse>
                    </li>
                    <li className="pr-6">
                      <button
                        type="button"
                        className="w-full flex items-center space-x-4 py-2 px-6 rounded-r-full hover:bg-error/5 active:bg-error/10"
                        onClick={() => {
                          setIsOpen(false);
                          logout();
                        }}
                      >
                        <LogoutIcon className="h-5 w-5 text-error" />
                        <span className="text-error text-xs">Logout</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </Dialog.Panel>
            </Transition.Child>
          </Transition.Child>
        </Dialog>
      </Transition> */}
      <header className="flex items-center justify-between p-6 text-white relative z-50 tab-screen">
        <div>
          {/* <img src={Logo} className="h-9" /> */}
          <h3 className="flex text-sm">{greetingsText}</h3>
          <h2 className="text-lg font-medium truncate">{fname}</h2>
        </div>
        {/* <div className="member flex items-center">
          <img src={Dimond} alt="Dimond img" className="header-icon" />
          <p className="dimond-text">
            Diamond <br />
            Member
          </p>
        </div> */}
        {/* <div className="flex items-center">
          <button className="flex items-center mr-4" onClick={viewRewards}>
            <img src={Coins} alt="coin img" className="header-icon" />
            <p className="coin-lineheight">
              <span className="coin-text">{balance < 0 ? "--" : balance}</span>
              <br />
              <span className="coin-subtext">Care Coins</span>
            </p>
          </button>

          <button
            className="flex-shrink-0"
            type="button"
            onClick={() => setIsOpen(true)}
          >
            <Menu className="h-6 w-6 text-white" />
          </button>
        </div> */}
        {/* <Link className="shrink-0" to="/add-goal">
          <span className="sr-only">Goal</span>
          <svg
            width="25"
            height="25"
            viewBox="0 0 37 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.2344 2.35684C13.1152 2.79043 9.8416 4.30801 7.07383 7.07578C4.57344 9.5834 3.06309 12.568 2.47773 16.1523C2.3043 17.258 2.3043 19.7439 2.47773 20.8496C3.04141 24.3039 4.50117 27.2596 6.84258 29.7094C9.30684 32.2748 12.5082 33.9297 16.1504 34.5223C17.2416 34.6957 19.7275 34.6957 20.8477 34.5223C25.5232 33.7852 29.4906 31.227 32.0705 27.2885C33.299 25.424 34.1373 23.2127 34.5203 20.8496C34.701 19.7295 34.701 17.2508 34.5203 16.1523C34.3396 15.0756 34.1229 14.2301 33.9566 13.9482C33.6676 13.4713 32.8293 13.3123 32.3813 13.6375C31.8537 14.035 31.7887 14.4035 32.0416 15.5381C32.7498 18.725 32.2945 22.0637 30.7625 24.9471C29.3678 27.5848 27.3299 29.5721 24.6777 30.8873C22.7771 31.834 21.1512 32.2604 19.0771 32.3543C14.5822 32.5566 10.0945 30.432 7.4207 26.826C2.14531 19.7295 4.63125 9.74961 12.6094 5.95566C15.3627 4.64766 18.4629 4.29355 21.4258 4.9584C22.4158 5.17519 22.676 5.17519 22.9795 4.96562C23.5215 4.6043 23.6805 4.09121 23.4275 3.52031C23.2541 3.12285 23.0518 2.98555 22.4158 2.80488C21.4258 2.53027 20.2406 2.37852 18.8604 2.34961C18.1232 2.34238 17.3934 2.34238 17.2344 2.35684Z"
              fill="#663CC7"
            />
            <path
              d="M28.942 2.45123C28.7541 2.53795 27.952 3.28951 26.6223 4.63365C24.7723 6.50533 24.5771 6.72213 24.4326 7.10514C24.2592 7.58209 24.2447 8.03736 24.3604 9.10689C24.4109 9.50435 24.4254 9.85123 24.4109 9.87291C24.3893 9.89459 24.1797 9.78619 23.9484 9.64166C23.0018 9.03463 21.6648 8.51431 20.4074 8.26138C19.4463 8.07349 17.4084 8.08795 16.4617 8.29752C14.3154 8.76724 12.6605 9.66334 11.1646 11.1665C9.94336 12.3805 9.12676 13.703 8.59922 15.3073C8.23066 16.4491 8.13672 17.1067 8.13672 18.5014C8.13672 19.8962 8.23066 20.5538 8.59922 21.6956C9.12676 23.2999 9.94336 24.6223 11.1646 25.8364C12.6605 27.3395 14.3227 28.2356 16.4617 28.7053C17.4012 28.9149 19.4463 28.9294 20.4074 28.7415C22.532 28.3151 24.3242 27.3612 25.8346 25.8436C27.3377 24.3405 28.2338 22.6784 28.7035 20.5393C28.9275 19.5276 28.9275 17.4753 28.7035 16.4635C28.4289 15.1917 27.9375 13.9559 27.3594 13.0526C27.2148 12.8213 27.1064 12.6118 27.1281 12.5901C27.1498 12.5756 27.4967 12.5901 27.8941 12.6407C28.9637 12.7563 29.4189 12.7419 29.8959 12.5684C30.2789 12.4239 30.4957 12.2288 32.3674 10.3788C34.4197 8.3481 34.6799 8.02291 34.6871 7.56764C34.6871 7.2858 34.5209 6.91724 34.2824 6.70045C34.0367 6.4692 33.7621 6.41139 32.1723 6.23795C31.0377 6.12232 30.9221 6.09342 30.8932 5.96334C30.8715 5.88385 30.792 5.22623 30.7125 4.5108C30.5607 3.09439 30.5246 2.94264 30.2789 2.68248C29.9248 2.31392 29.4262 2.22721 28.942 2.45123ZM28.6529 6.80885C28.7469 7.90728 29.1154 8.25416 30.25 8.3481C30.5824 8.37701 30.8715 8.4276 30.8932 8.44928C30.9076 8.47818 30.4885 8.93346 29.9537 9.46822L28.9926 10.4294L27.923 10.3065C27.3377 10.2415 26.8463 10.1764 26.8318 10.162C26.8102 10.1475 26.7451 9.65611 26.6873 9.07076L26.5645 8.01568L27.5328 7.04732C28.1615 6.41861 28.5229 6.10787 28.5518 6.16568C28.5807 6.20904 28.624 6.50533 28.6529 6.80885ZM19.6775 11.6723C20.0244 11.7301 20.5664 11.8819 20.8988 11.9975C21.477 12.2071 22.4742 12.7491 22.4742 12.8503C22.4742 12.8792 21.9178 13.4573 21.2385 14.1366L20.0027 15.3723L19.627 15.235C17.7986 14.534 15.6523 15.7047 15.1393 17.6848C14.6695 19.4842 15.8186 21.3776 17.683 21.8618C19.533 22.346 21.4986 21.0885 21.9033 19.1735C22.0117 18.646 21.9539 17.851 21.766 17.3741L21.6287 16.9983L22.8861 15.7481L24.1436 14.4907L24.2809 14.6713C24.5049 14.9532 24.9746 15.9577 25.1336 16.4852C25.4805 17.6198 25.5166 19.0506 25.2275 20.1708C24.5699 22.7073 22.6188 24.6295 20.0461 25.2727C19.2873 25.4606 17.6324 25.4461 16.8592 25.2438C15.1176 24.7813 13.6217 23.719 12.6895 22.2809C11.2369 20.0335 11.2008 17.1428 12.5883 14.8881C14.077 12.4672 16.9025 11.1881 19.6775 11.6723Z"
              fill="#663CC7"
            />
          </svg>
        </Link> */}
        <Link className="shrink-0" to="/my-profile">
          <span className="sr-only">My Profile</span>
          <img src={UserIcon} alt="" className=" h-7" />
        </Link>
      </header>
      <Outlet />
      <footer className="fixed bottom-4 left-3 right-3 z-50 h-12 flex justify-between items-center bg-white rounded-full bottom-tab hidden">
        <Link
          to="/unity-score"
          onClick={() => handleClick("/unity-score")}
          className={`rounded ${
            activeLink === "/unity-score"
              ? "bg-[#152445] text-white rounded-full flex justify-center items-center h-12 active"
              : "text-gray-700 flex flex-row items-center justify-center w-4/12"
          }`}
        >
          <h6 className="text-xs font-semibold from-[#EAEAEA] via-[#455C8E] to-[#41a0e1] bg-gradient-to-r bg-clip-text text-transparent">
            UnityScore{" "}
          </h6>
          <span className="text-[6px] text-[#4C6393]">&trade;</span>
        </Link>
        {/* <Link
          to=""
          className="flex flex-col items-center"
          activeClassName="active"
        > */}
        <Link
          to="/"
          onClick={() => handleClick("/")}
          className={`rounded ${
            activeLink === "/"
              ? "bg-[#152445] text-white rounded-full flex flex-col justify-center items-center h-12 active"
              : "text-black/70 flex flex-col items-center w-4/12 inactive"
          }`}
        >
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="none"
            viewBox="0 0 22 22"
          >
            <path
              d="M6.6,1.4c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0
	c0.4,0,0.7,0.1,1,0.4C8.8,2,8.9,2.1,9,2.4c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.1,0c0.4,0,0.7,0.1,1.1,0.4
	C10.9,2.9,11,3.1,11,3.3c0,0,0.1,0,0.1,0c0.2,0,0.3,0,0.5,0c0.1,0,0.1,0,0.2,0c1,0,1,0,1.4,0.4c0.3,0.4,0.4,0.8,0.4,1.3
	c0,0.1,0,0.1,0,0.1c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3c0,0.2,0,0.5,0,0.7c0,0,0.1,0,0.1,0c0.5,0.2,0.9,0.6,1.3,1
	c0.1-0.1,0.3-0.2,0.4-0.4c0.7-0.7,1.6-1,2.5-1c0.9,0,1.6,0.3,2.3,0.8c0,0,0.1,0,0.1,0.1c0.6,0.5,1,1.3,1.2,2.1c0,0.6,0,1.2-0.2,1.8
	c0,0,0,0.1-0.1,0.1c-0.3,0.7-0.7,1.2-1.3,1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c0,0-0.1,0.1-0.1,0.1
	c-0.2,0.2-0.2,0.2-0.4,0.3c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2,0-0.4c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0.1-0.1
	c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.4-0.4,0.8-0.8,1-1.3c0,0,0-0.1,0-0.1
	c0.3-0.8,0.2-1.7-0.2-2.4c-0.4-0.7-1-1.1-1.7-1.3c-0.8-0.2-1.6-0.1-2.4,0.4c-0.3,0.2-0.6,0.5-0.8,0.8c0,0-0.1,0.1-0.1,0.1
	c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.3-0.1-0.4-0.3-0.6-0.5c-0.6-0.6-1.2-1-2.1-1c-0.8,0-1.5,0.2-2.1,0.8
	C9.6,8.3,9.3,9,9.3,9.8c0,1.2,0.7,1.9,1.5,2.7c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.3,0.3,0.4,0.4c0.1,0.1,0.3,0.3,0.4,0.4
	c0.2,0.2,0.5,0.5,0.7,0.7c0.3,0.3,0.6,0.6,0.8,0.8c0.6,0.6,1.2,1.2,1.7,1.7c0.2-0.2,0.4-0.3,0.5-0.5c0,0,0,0,0.1-0.1
	c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.2-0.2c0.2-0.2,0.3-0.3,0.5-0.5c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.2-0.2,0.2-0.2
	c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0.1-0.1c0.2-0.2,0.2-0.2,0.4-0.2c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3
	c-0.1,0.2-0.2,0.3-0.4,0.5c0,0,0,0-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.3,0.3-0.4,0.4
	c-0.2,0.2-0.3,0.4-0.5,0.5c-0.1,0.1-0.3,0.3-0.4,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c0,0-0.1,0.1-0.1,0.1
	c-0.2,0.2-0.2,0.2-0.4,0.2c-0.2,0-0.3-0.2-0.5-0.3c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.1-0.1-0.1-0.2-0.2
	c-0.1-0.1-0.3-0.3-0.4-0.4c0,0,0,0.1,0,0.1c0,0.4,0,0.7,0,1.1c0,0.2,0,0.4,0,0.5c0,0.2,0,0.4,0,0.5c0,0.1,0,0.1,0,0.2
	c0,0.5,0,1-0.4,1.4c-0.3,0.3-0.7,0.3-1.1,0.3c0,0-0.1,0-0.1,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.3,0-0.5,0-0.8,0
	c-0.2,0-0.4,0-0.6,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.6,0-1.1,0-1.7,0c-0.5,0-1,0-1.6,0c-0.5,0-1.1,0-1.6,0
	c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6,0-0.9,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.1,0c-0.4,0-0.7-0.1-1-0.4
	c-0.2-0.3-0.3-0.5-0.3-0.8c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6c0-0.2,0-0.3,0-0.5
	c0-0.4,0-0.7,0-1.1c0-0.4,0-0.8,0-1.2c0-0.3,0-0.7,0-1c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3
	c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0.1,0.2,0.1,0.2,0.3c0,0,0,0.1,0,0.2c0,0,0,0.1,0,0.1
	c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0.1,0,0.3,0,0.4c0,0.2,0,0.5,0,0.7c0,0.4,0,0.7,0,1.1c0,0.6,0,1.3,0,1.9c0,0.2,0,0.5,0,0.7
	c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.2c0,0.2,0,0.4,0.1,0.5c0.2,0.1,0.3,0.2,0.5,0.2
	c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,0.9,0c0.2,0,0.4,0,0.5,0
	c0.5,0,1,0,1.5,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c0.5,0,1,0,1.6,0c0.5,0,1.1,0,1.6,0
	c0.3,0,0.6,0,0.9,0c0.3,0,0.6,0,0.8,0c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0,0.4,0c0,0,0.1,0,0.1,0c0.2,0,0.4,0,0.6-0.1
	c0.4-0.4,0.4-1.4,0.4-2c0,0,0-0.1,0-0.1c0.1-1.1-0.1-2-0.9-2.8c-0.3-0.4-0.7-0.7-1-1c0,0,0,0-0.1-0.1c-0.4-0.3-0.7-0.7-1.1-1
	c-0.7-0.5-0.7-0.5-0.9-0.9c0,0,0-0.1-0.1-0.1c0-0.1-0.1-0.2-0.1-0.2c0,0,0-0.1,0-0.1c-0.4-0.8-0.4-1.8-0.2-2.7
	c0.3-0.9,1-1.7,1.9-2.1c0.7-0.3,1.5-0.4,2.2-0.3c0-0.2,0-0.5,0-0.7c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.4c0,0,0-0.1,0-0.1
	c0-0.2,0-0.4-0.1-0.6C12.6,4,12.4,4,12.1,4c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5,0
	C11,4,11,4,11,4.1c-0.1,0.3-0.3,0.5-0.6,0.7C10.2,4.9,10,5,9.8,5c0,0-0.1,0-0.1,0C9.4,5,9.2,5,9,5C8.9,5,8.8,5,8.7,5
	C8.5,5,8.3,5,8.2,5c0,0-0.1,0-0.2,0C7.6,5,7.6,5,7.5,4.9C7.4,4.7,7.4,4.7,7.4,4.5c0.1-0.1,0.1-0.1,0.2-0.2c0.2,0,0.3,0,0.5,0
	c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.3,0c0.3,0,0.3,0,0.6-0.1c0.2-0.2,0.2-0.3,0.2-0.6
	c0-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.1c-0.2-0.1-0.4-0.1-0.6-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0
	c0,0-0.1,0-0.1,0c-0.2,0-0.3,0-0.4-0.1c0-0.1,0-0.1-0.1-0.2c0-0.2-0.1-0.3-0.2-0.5C7.9,2.1,7.7,2.1,7.5,2.1c0,0-0.1,0-0.1,0
	c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0C6.3,2.1,6.2,2.1,6,2.3C5.9,2.4,5.8,2.6,5.8,2.8
	c0,0.2,0,0.2-0.1,0.2C5.5,3.1,5.4,3.1,5.2,3.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0
	c-0.2,0-0.3,0-0.4,0.1c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.2c0,0.2,0,0.3,0.1,0.5C4,4.1,4.1,4.2,4.2,4.3
	c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0c0,0,0.1,0,0.1,0
	c0.4,0,0.4,0,0.5,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.2,0.3C6.4,5,6.2,5,6,5C5.9,5,5.9,5,5.8,5C5.7,5,5.6,5,5.5,5
	C5.4,5,5.3,5,5.2,5C5,5,4.9,5,4.7,5C4.6,5,4.6,5,4.6,5C4.1,5,3.8,4.9,3.4,4.6C3.3,4.4,3.2,4.2,3.1,4C2.9,4,2.7,4,2.6,4
	C2.5,4,2.4,4,2.4,4C2.3,4,2.2,4,2.1,4C2,4,2,4,2,4c-0.2,0-0.3,0-0.5,0.1C1.3,4.4,1.3,4.6,1.3,4.9c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3
	c0,0.1,0,0.1,0,0.2c0,0.1,0,0.3,0,0.4c0,0.2,0,0.5,0,0.7c0,0.6,0,1.3,0,1.9c0,0.4,0,0.7,0,1.1c0,0.2,0,0.4,0,0.6c0,0.2,0,0.4,0,0.5
	c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.2-0.2
	c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6c0-0.1,0-0.2,0-0.4c0-0.4,0-0.7,0-1.1
	c0-0.4,0-0.9,0-1.3c0-0.3,0-0.7,0-1c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6c0-0.1,0-0.1,0-0.2c0-0.5,0-0.8,0.4-1.2
	c0.3-0.3,0.7-0.3,1-0.3c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0,0.5,0c0-0.1,0-0.1,0-0.1
	c0.1-0.3,0.3-0.5,0.6-0.7c0.2-0.1,0.4-0.1,0.6-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4,0
	c0-0.1,0-0.1,0-0.1C5.3,2,5.5,1.7,5.8,1.5C6.1,1.4,6.3,1.4,6.6,1.4z"
            />
            <path
              d="M14.5,9.2c0.2,0.1,0.2,0.2,0.3,0.4c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0.1,0.2c0,0.1,0,0.1,0.1,0.2
	c0,0.1,0.1,0.3,0.1,0.4c0.1,0.2,0.1,0.3,0.2,0.5c0,0.1,0.1,0.3,0.1,0.4c0.1,0.3,0.2,0.6,0.4,1c0,0,0-0.1,0-0.1
	c0.1-0.1,0.1-0.3,0.2-0.4c0,0,0-0.1,0.1-0.1c0-0.1,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.2,0.2-0.3c0.1,0,0.1,0,0.3,0
	c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.4,0c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0c0.1,0,0.1,0,0.2,0
	c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.1,0c0.1,0,0.2,0.1,0.3,0.2c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1-0.1,0.2-0.2,0.2
	c-0.2,0-0.3,0-0.5,0c0,0-0.1,0-0.1,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.2,0-0.3,0c-0.3,0-0.5,0-0.8,0c0,0,0,0,0,0.1
	c-0.1,0.3-0.2,0.6-0.3,0.9c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0,0,0,0,0,0.1c-0.1,0.2-0.1,0.3-0.3,0.4c-0.1,0-0.2,0-0.4,0
	c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3
	c-0.1-0.2-0.1-0.4-0.2-0.6c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.4-0.3-0.8-0.4-1.2c0,0.1,0,0.1,0,0.1c-0.1,0.1-0.1,0.3-0.2,0.4
	c0,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0,0,0,0.1,0,0.1c-0.1,0.1-0.1,0.2-0.3,0.3c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0
	c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.2,0
	c-0.1,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3-0.1c0-0.2-0.1-0.2,0-0.4c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0
	c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.3,0c0.2,0,0.5,0,0.7,0c0,0,0-0.1,0-0.1
	c0.1-0.2,0.1-0.3,0.2-0.5c0,0,0-0.1,0-0.1c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.2-0.3,0.2-0.4
	C14,9.5,14,9.5,14,9.4C14.1,9.2,14.2,9.2,14.5,9.2z"
            />
            <path
              d="M2.9,14.6c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1,0
	c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.4c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1
	c0,0.1,0,0.2,0,0.3c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.2-0.1,0.3
	c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0
	c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1
	c0-0.2,0-0.4,0-0.6c0-0.1,0-0.2,0-0.3c0-0.2,0-0.3,0-0.5c0,0,0-0.1,0-0.1c0-0.2,0-0.3,0.1-0.5C2.4,14.6,2.6,14.6,2.9,14.6z
	 M2.8,15.3c0,0.5,0,0.9,0,1.4c0.5,0,0.9,0,1.4,0c0-0.5,0-0.9,0-1.4C3.8,15.3,3.3,15.3,2.8,15.3z"
            />
            <path
              d="M2.9,10.5c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0,0.2,0c0.2,0,0.3,0,0.5,0c0,0,0.1,0,0.1,0
	c0.2,0,0.3,0,0.5,0.1c0.1,0.2,0.1,0.4,0.1,0.6c0,0,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.3
	c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1,0
	c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.2,0
	c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
	c0,0,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1c0-0.2,0-0.3,0.1-0.5
	C2.4,10.5,2.6,10.5,2.9,10.5z M2.8,11.2c0,0.5,0,0.9,0,1.4c0.5,0,0.9,0,1.4,0c0-0.5,0-0.9,0-1.4C3.8,11.2,3.3,11.2,2.8,11.2z"
            />
            <path
              d="M2.6,6.4c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0,0.4,0
	c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3
	c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1
	c0,0.2,0,0.3-0.1,0.5C4.6,9.2,4.4,9.2,4.2,9.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.2,0c-0.2,0-0.3,0-0.5,0
	c0,0-0.1,0-0.1,0c-0.2,0-0.3,0-0.5-0.1C2.1,8.9,2.1,8.7,2.1,8.4c0,0,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0-0.2,0-0.3,0-0.5
	c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1C2.2,6.5,2.3,6.4,2.6,6.4z M2.8,7.1c0,0.5,0,0.9,0,1.4
	c0.5,0,0.9,0,1.4,0c0-0.5,0-0.9,0-1.4C3.8,7.1,3.3,7.1,2.8,7.1z"
            />
            <path
              d="M6.1,15C6.1,15,6.2,15,6.1,15c0.2,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0,0.5,0c0.2,0,0.4,0,0.6,0
	c0.2,0,0.3,0,0.5,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0,0,0,0,0.1,0c0.2,0,0.2,0,0.4,0.1c0.1,0.1,0.1,0.1,0.1,0.2
	c0,0.2-0.1,0.2-0.2,0.3c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5,0
	c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c-0.2,0-0.2,0-0.4-0.1
	c-0.1-0.1-0.1-0.1-0.1-0.3c0-0.1,0-0.1,0.1-0.2C5.8,15,5.9,15,6.1,15z"
            />
            <path
              d="M6.1,6.8C6.1,6.8,6.1,6.8,6.1,6.8c0.2,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4,0c0.2,0,0.3,0,0.5,0
	c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0.1C8.9,7,8.9,7,8.9,7.2
	c0,0.2,0,0.2-0.2,0.3c-0.1,0-0.1,0-0.3,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4,0
	c-0.2,0-0.4,0-0.5,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2-0.1
	C5.5,7.2,5.6,7.2,5.6,7C5.7,6.8,5.9,6.8,6.1,6.8z"
            />
            <path
              d="M6,12.2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0,0.5,0
	c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0.1,0.3,0.2c0,0.2,0,0.2-0.1,0.4
	c-0.1,0.1-0.2,0.1-0.4,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0
	c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.1-0.2,0-0.4
	C5.7,12.3,5.8,12.2,6,12.2z"
            />
            <path
              d="M6.3,16.3c0.1,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0
	c0.3,0,0.3,0,0.5,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0.1c0,0.1-0.1,0.2-0.2,0.2c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.1,0
	c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c-0.3,0-0.3,0-0.5-0.1c-0.1-0.1-0.1-0.1-0.1-0.2
	C5.6,16.3,5.9,16.3,6.3,16.3z"
            />
            <path
              d="M6,10.9c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0,0.5,0
	c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0.1,0.3,0.2c0,0.2,0,0.2-0.1,0.4
	c-0.1,0.1-0.2,0.1-0.4,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0
	c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.1,0c-0.2,0-0.4,0-0.6-0.1c-0.1-0.1-0.1-0.2,0-0.4C5.7,10.9,5.8,10.9,6,10.9z"
            />
            <path
              d="M6.1,8.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0,0.4,0
	c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0.4,0,0.4,0,0.5,0.1c0.1,0.1,0.1,0.2,0,0.4C8.1,8.7,8,8.8,7.9,8.8c0,0-0.1,0-0.1,0
	c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0
	C6,8.8,6,8.8,6,8.8c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.3-0.2c0-0.1,0-0.1,0-0.3C5.7,8.2,5.8,8.1,6.1,8.1z"
            />
          </svg>
          <p className="text-xxs mt-[2px]">Assessments</p>
        </Link>
        {/* <Link
          to="/start-scan"
          className="flex flex-col items-center"
          activeClassName="active"
        > */}
        <Link
          to="/start-scan"
          onClick={() => handleClick("/start-scan")}
          className={`rounded ${
            activeLink === "/start-scan"
              ? "bg-[#152445] text-white rounded-full flex flex-col justify-center items-center h-12 active"
              : "text-black/70 flex flex-col items-center w-4/12 inactive"
          }`}
        >
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.6,7.7c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0c0.2,0,0.5,0,0.7,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.4,0
	c0,0,0.1,0,0.1,0c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.1,0.1,0.3c0,0.1,0,0.1-0.2,0.2c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0
	c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.7,0c0,0.3,0,0.6,0,1c0.1,0,0.1,0,0.2,0
	c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1,0c0.4,0,0.4,0,0.5,0.1C17,9.8,17,9.8,17,9.9c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1,0-0.3,0
	c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4,0c0,0.3,0,0.6,0,1c0.2,0,0.2,0,0.4,0c0.1,0,0.2,0,0.4,0
	c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.4,0c0.1,0,0.1,0,0.1,0c0.3,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.3c-0.1,0.1-0.1,0.1-0.2,0.2
	c-0.1,0-0.3,0-0.4,0c0,0-0.1,0-0.1,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.6,0c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2
	c0,0,0,0.1,0,0.2c0,0.3-0.1,0.5-0.3,0.7c-0.3,0.2-0.5,0.3-0.9,0.3c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0.1,0,0.1,0,0.1
	c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1c0,0.2,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1
	c-0.2-0.1-0.2-0.1-0.2-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.5
	c-0.3,0-0.6,0-0.9,0c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1
	c0,0.1-0.1,0.3-0.2,0.4c-0.3,0-0.3,0-0.4-0.1c-0.1-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
	c0-0.1,0-0.2,0-0.4c-0.3,0-0.6,0-0.9,0c0,0.1,0,0.1,0,0.2c0,0.2,0,0.5,0,0.7c0,0.1,0,0.2,0,0.3c0,0.2,0,0.3,0,0.5c0,0,0,0.1,0,0.1
	c0,0.3,0,0.3-0.1,0.5c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1-0.1-0.2-0.1-0.2-0.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
	c0-0.1,0-0.1,0-0.1c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3c0-0.3,0-0.5,0-0.8c-0.3,0-0.6,0-0.9,0c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3
	c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.1,0-0.3,0c-0.1-0.1-0.2-0.2-0.2-0.3
	c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0
	c0,0-0.1,0-0.1,0c-0.3,0-0.5-0.1-0.8-0.3c-0.2-0.3-0.3-0.5-0.3-0.9c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0,0-0.1,0
	c-0.3,0-0.6,0-0.8,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0
	c-0.1,0-0.2-0.1-0.3-0.2c0-0.2,0-0.2,0-0.4c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0
	c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.3,0,0.6,0,0.9,0c0,0,0,0,0-0.1c0-0.1,0-0.1,0.1-0.2c0.2,0,0.2,0,0.4,0.1
	c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1c0,0.2,0.1,0.3,0.2,0.4
	c0.1,0.1,0.2,0.1,0.4,0.1c0,0,0,0,0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0,0.5,0c0.2,0,0.4,0,0.5,0c0.3,0,0.7,0,1,0
	c0.4,0,0.8,0,1.1,0c0.8,0,1.6,0,2.4,0c0-0.1,0-0.1,0.1-0.2c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1c0-0.5,0-1.1,0-1.6c0-0.3,0-0.5,0-0.8
	c0-0.3,0-0.5,0-0.8c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c0-0.2,0-0.3,0.1-0.5C15.4,7.7,15.5,7.7,15.6,7.7z"
            />
            <path
              d="M11.1,2.7c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.3,0,0.4c0,0,0,0.1,0,0.1c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.3
	c0,0.3,0,0.5,0,0.8c0.3,0,0.6,0,0.9,0c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
	c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3,0c0.1,0.1,0.2,0.1,0.2,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1
	c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3c0.3,0,0.6,0,0.9,0c0-0.1,0-0.2,0-0.4c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3
	c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0-0.1,0.1-0.1,0.1-0.2c0.2,0,0.2,0,0.4,0.1c0.1,0.2,0.1,0.3,0.1,0.5c0,0,0,0.1,0,0.1
	c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2c0,0.2,0,0.4,0,0.6c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.3,0,0.5,0.1,0.7,0.3
	c0.3,0.3,0.3,0.5,0.3,0.9c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0
	c0.1,0,0.1,0,0.1,0c0.1,0,0.2,0.1,0.3,0.2c0,0.1,0,0.1,0,0.2C16.9,7,16.9,7,16.8,7.1c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0
	c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.1-0.5-0.1-0.8
	c0-0.2,0-0.3-0.1-0.5c-0.2-0.1-0.3-0.1-0.5-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5,0
	c-0.1,0-0.3,0-0.4,0c-0.3,0-0.6,0-1,0c-0.3,0-0.7,0-1,0c-0.3,0-0.6,0-0.8,0c-0.2,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.5,0
	c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.1,0c-0.1,0-0.2,0.1-0.4,0.1C8.3,6,8.3,6.2,8.3,6.5c0,0,0,0.1,0,0.1
	c0,0.1,0,0.2,0,0.3c0,0.1,0,0.3,0,0.4c0,0.4,0,0.8,0,1.2c0,0.2,0,0.5,0,0.7c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.1
	c0,0.3,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1,0-0.1,0-0.2c0,0,0,0-0.1,0c-0.1,0-0.3,0-0.4,0
	c0,0-0.1,0-0.1,0c-0.4,0-0.4,0-0.6-0.1c-0.1-0.1-0.1-0.2,0-0.3c0.1-0.1,0.1-0.2,0.3-0.2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0
	c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4,0c0-0.3,0-0.6,0-0.9c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0
	c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.1,0c-0.3,0-0.3,0-0.5-0.1C5.6,8.4,5.6,8.4,5.6,8.3c0-0.2,0.1-0.2,0.2-0.3
	C5.9,8,5.9,8,6,8C6,8,6,8,6.1,8c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0C6.8,8,6.9,8,7,8c0.2,0,0.5,0,0.7,0
	c0-0.3,0-0.6,0-0.9c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c-0.4,0-0.4,0-0.5-0.1C6.5,6.9,6.4,6.9,6.5,6.7
	c0-0.2,0-0.2,0.1-0.2c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.4,0c0,0,0-0.1,0-0.1
	c0-0.3,0-0.6,0.2-0.8c0,0,0,0,0-0.1c0.2-0.2,0.4-0.3,0.6-0.4c0.1,0,0.2,0,0.3,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0-0.1,0-0.1
	c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.3c0.2-0.1,0.2-0.1,0.3,0
	C9.6,3.9,9.7,3.9,9.7,4c0,0.2,0,0.4,0,0.5c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.4c0.3,0,0.6,0,0.9,0c0-0.1,0-0.1,0-0.2
	c0-0.2,0-0.5,0-0.7c0-0.1,0-0.2,0-0.3c0-0.2,0-0.3,0-0.5c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0-0.1,0.1-0.2,0.1-0.3
	C10.9,2.7,11,2.7,11.1,2.7z"
            />
            <path
              d="M4,10.4C4,10.6,4.1,10.6,4,10.8c-0.2,0.3-0.4,0.5-0.6,0.7c-0.4,0.4-1,1.1-1.1,1.6c0,0.1,0,0.2,0.1,0.3
	c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.4,0.2,0.5,0.5c0,0.3,0,0.4-0.2,0.6c-0.1,0.1-0.2,0.3-0.2,0.4c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0
	c0,0,0.1,0,0.1,0c0.1,0,0.1,0.1,0.2,0.2c0,0.2,0,0.3-0.1,0.4C3.4,16,3.4,16,3.4,16.1c0.1,0.1,0.1,0.2,0.2,0.3
	c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0,0.1,0.1C4,16.8,4,17,4,17.2c0,0.1,0,0.2-0.1,0.3c-0.1,0.4-0.1,0.8,0.1,1.1
	c0.2,0.3,0.4,0.5,0.7,0.6c0.4,0.1,0.8,0,1.2-0.1C6.5,19,7,19,7.5,18.9c0.4,0,0.8-0.1,1.1-0.1c0.1,0,0.1,0,0.2,0
	c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.1,0.2,0,0.4c-0.2,0.2-0.4,0.2-0.7,0.3c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0.1
	c0,0,0,0,0,0.1c0.1,0.2,0.3,0.4,0.4,0.7c0,0,0,0.1,0,0.1c0.1,0.2,0.1,0.2,0.1,0.3c0,0,0.1,0,0.1,0c0.8,0,1.6,0,2.3,0
	c0.4,0,0.7,0,1.1,0c0.3,0,0.7,0,1,0c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1,0
	c0.2,0,0.2,0.1,0.3,0.2c0,0.1,0,0.1,0,0.3c-0.2,0.1-0.3,0.1-0.5,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0
	c-0.2,0-0.3,0-0.5,0c-0.2,0-0.4,0-0.5,0c-0.3,0-0.6,0-0.9,0c-0.3,0-0.7,0-1,0c-0.3,0-0.6,0-0.9,0c-0.2,0-0.4,0-0.5,0
	c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.3
	c-0.1-0.1-0.1-0.2-0.2-0.4c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.2-0.2-0.4-0.4-0.5c-0.7-0.2-1.5,0-2.2,0.1c-0.7,0.1-1.2,0.1-1.8-0.3
	c-0.4-0.3-0.7-0.8-0.8-1.4c0-0.3,0-0.6,0.1-0.8c0-0.2,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.1c-0.2-0.2-0.3-0.3-0.4-0.6
	c0-0.1,0-0.2,0-0.2c0-0.2,0-0.3-0.1-0.4c-0.1,0-0.1,0-0.1-0.1c-0.1-0.2-0.1-0.5,0-0.7c0.1-0.1,0.2-0.3,0.3-0.4c0,0-0.1,0-0.1,0
	c-0.4-0.2-0.8-0.3-1-0.7c-0.1-0.3-0.1-0.5,0-0.8C1.9,12.5,2,12.2,2.2,12c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.2,0.2-0.3
	c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.2,0.2-0.2C3,11.1,3.1,11,3.3,10.8c0,0,0,0,0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.3
	C3.7,10.3,3.8,10.3,4,10.4z"
            />
            <path
              d="M17.2,2.7c0.1,0.1,0.2,0.2,0.3,0.2c0,0,0,0,0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0,0,0,0,0.1,0.1c0.7,0.6,1.3,1.3,1.7,2.2
	c0,0,0,0,0,0.1c0.9,1.7,0.8,3.8,0.2,5.7c-0.2,0.6-0.4,1.2-0.7,1.8c-0.3,0.7-0.6,1.5-0.9,2.2c0,0,0,0.1,0,0.1c-0.5,1.5-0.9,3.1-1,4.7
	c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3c0,0.3,0,0.3-0.1,0.5c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.2-0.2c-0.2-1.8,0.5-3.9,1-5.6
	c0,0,0-0.1,0-0.1c0.1-0.4,0.3-0.8,0.5-1.2c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.2,0.2-0.4,0.3-0.6c1-1.9,1.5-4.2,0.9-6.3
	c-0.4-1.3-1.2-2.4-2.3-3.2c-0.2-0.1-0.3-0.2-0.4-0.4c0-0.1,0-0.1,0-0.2C16.9,2.7,17,2.7,17.2,2.7z"
            />
            <path
              d="M11.9,1C12,1,12,1,11.9,1C13,1,14,1.2,15,1.6c0.1,0,0.1,0,0.1,0c0.2,0.1,0.3,0.1,0.5,0.3c0,0.1,0,0.1,0,0.3
	c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0-0.5-0.1-0.7-0.2c-0.5-0.2-0.9-0.3-1.4-0.4c-0.1,0-0.1,0-0.1,0c-1-0.2-2.1-0.2-3.1,0
	c0,0-0.1,0-0.1,0c-1.5,0.3-2.8,1-3.9,2.1c0,0-0.1,0-0.1,0.1C5.3,4.5,4.8,5.3,4.6,6.2c0,0,0,0,0,0.1C4.3,7.1,4.3,7.9,4.4,8.7
	c0,0.1,0,0.3,0,0.4c0,0,0,0.1,0,0.1c0,0.3,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.4,0C3.8,9.6,3.8,9.4,3.7,9.2c0,0,0-0.1,0-0.1
	c-0.1-1.5,0-3,0.8-4.4c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.2,0.2-0.4c0,0,0.1,0,0.1,0C4.9,4.2,5,4.1,5,4.1
	c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0-0.1,0.1-0.1,0.1-0.2C5.5,3.4,5.8,3.2,6,3c0,0,0.1,0,0.1,0
	c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0.1-0.1,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1-0.1
	c0.1,0,0.1,0,0.2,0c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1C8.5,1.4,10.1,0.9,11.9,1z"
            />
            <path
              d="M14,7.7c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0.1,0,0.3,0,0.4
	c0,0.2,0,0.4,0,0.6c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0,0.1c0,0.2-0.1,0.4-0.2,0.5
	c-0.2,0.2-0.4,0.2-0.7,0.2c-0.1,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.4,0c0,0-0.1,0-0.1,0c-0.2,0-0.5,0-0.7,0c-0.2,0-0.5,0-0.7,0
	c-0.2,0-0.4,0-0.5,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.4,0c0,0-0.1,0-0.1,0c-0.2,0-0.4,0-0.6-0.2c-0.1-0.1-0.2-0.2-0.2-0.4
	c0-0.1,0-0.1,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0.1,0,0.1c1.2,0,2.5,0,3.7,0c0-1,0-1,0-1.9
	c0-0.2,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0.1-0.3C13.8,7.7,13.9,7.7,14,7.7z"
            />
            <path
              d="M9.9,6.7c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4,0c0,0,0.1,0,0.1,0c0.2,0,0.5,0,0.7,0
	c0.2,0,0.5,0,0.7,0c0.2,0,0.4,0,0.6,0c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0,0.4,0c0,0,0.1,0,0.1,0c0.3,0,0.4,0.1,0.6,0.3
	c0.1,0.1,0.1,0.3,0.1,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.1,0-0.3,0c0,0,0-0.1,0-0.1c-0.1-0.1-0.1-0.1-0.2-0.1
	c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2,0-0.2,0c-0.2,0-0.4,0-0.7,0c-0.2,0-0.4,0-0.7,0
	c-0.4,0-0.9,0-1.3,0c0,0,0,0.1,0,0.1c0,0.4,0,0.7,0,1.1c0,0.2,0,0.4,0,0.5c0,0.2,0,0.4,0,0.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3
	c0,0,0,0.1,0,0.1c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.4,0c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1
	c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0-0.4c0-0.2,0-0.4,0-0.6c0-0.1,0-0.3,0-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3
	c0,0,0-0.1,0-0.1c0-0.2,0-0.3,0.1-0.5C9.5,6.7,9.7,6.7,9.9,6.7z"
            />
            <path
              d="M12.2,17c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.2,0.1,0.3c-0.3,0.7-0.9,1-1.6,1.4c0,0,0,0-0.1,0c-0.2,0.1-0.3,0.1-0.5,0.1
	c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1,0-0.1,0-0.3c0.1-0.1,0.3-0.2,0.4-0.2c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0,0.1,0,0.2,0c0,0,0-0.1,0-0.1
	c0.1-0.1,0.1-0.1,0.2-0.1c0.2-0.2,0.4-0.3,0.5-0.6C12,17.1,12,17,12.2,17z"
            />
          </svg>
          <p className="text-xxs mt-[2px]">UnityAgent</p>
        </Link>
        {/* <Link to="/vouchers" className="flex flex-col items-center">
          <svg width="21" height="21" viewBox="0 0 5120 5120">
            <path
              d="M507 4230 c-173 -22 -315 -168 -338 -348 -11 -87 -11 -2557 0 -2644 24 -185 164 -325 347 -349 90 -11 3998 -11 4088 0 183 24 323 164 347 349 11 88 11 2557 0 2646 -24 183 -164 323 -349 347 -81 10 -4013 9 -4095 -1z m1093 -577 l0 -428 -183 183 c-170 170 -185 182 -219 182 -43 0 -68 -27 -68 -75 0 -25 27 -56 182 -212 l183 -183 -588 0 -587 0 0 390 c0 309 3 398 14 424 20 48 71 101 119 125 41 21 54 21 595 21 l552 0 0 -427z m3065 408 c46 -20 101 -79 121 -127 11 -26 14 -115 14 -424 l0 -390 -1467 0 -1468 0 183 183 c155 156 182 187 182 212 0 48 -25 75 -68 75 -34 0 -49 -12 -219 -182 l-183 -183 0 428 0 427 1433 0 c1363 0 1434 -1 1472 -19z m-3691 -1113 c-4 -7 -18 -27 -31 -44 -61 -81 -73 -223 -28 -322 34 -74 74 -114 147 -147 50 -23 73 -27 148 -26 138 0 238 32 343 108 l47 35 0 -756 0 -756 -564 2 -564 3 -43 30 c-24 17 -57 50 -74 74 l-30 43 -3 884 -2 884 330 0 c262 0 330 -3 324 -12z m623 -58 c-11 -132 -79 -235 -193 -291 -54 -27 -79 -33 -157 -37 -152 -8 -207 32 -207 151 0 64 14 99 57 138 83 77 188 108 372 108 l134 1 -6 -70z m525 41 c75 -24 141 -70 175 -120 31 -46 32 -141 3 -189 -31 -50 -77 -65 -186 -60 -69 4 -104 11 -146 30 -120 55 -194 162 -205 297 l-6 73 149 -4 c118 -4 163 -9 216 -27z m2678 -841 c0 -716 -2 -876 -14 -904 -20 -48 -75 -107 -121 -127 -38 -18 -109 -19 -1472 -19 l-1433 0 0 756 0 756 23 -16 c112 -82 179 -111 294 -125 237 -28 393 90 394 301 0 42 -7 92 -16 117 -15 42 -57 108 -79 123 -6 4 537 8 1207 8 l1217 0 0 -870z"
              fill="#fff"
            />
            <path
              d="M3263 2153 c-51 -10 -71 -93 -32 -129 20 -18 44 -19 529 -19 485 0 509 1 529 19 29 26 29 86 0 112 -20 18 -44 19 -513 20 -270 1 -501 0 -513 -3z"
              fill="#fff"
            />
            <path
              d="M3023 1593 c-51 -10 -71 -93 -32 -129 20 -18 46 -19 649 -19 603 0 629 1 649 19 29 26 29 86 0 112 -20 18 -46 19 -633 20 -336 1 -621 0 -633 -3z"
              fill="#fff"
            />
          </svg>
          <p className="text-xxs text-white mt-1">Vouchers</p>
        </Link> */}
        {/* <button
          type="button"
          onClick={viewRewards}
          className="flex flex-col items-center"
        >
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.1361 0.0246105C11.2017 0.032814 11.4068 0.0615234 11.5872 0.086134C14.7454 0.49629 17.4443 2.8957 18.2318 5.98828C18.7034 7.83809 18.5271 9.72891 17.7232 11.4229C17.1777 12.5713 16.2384 13.7033 15.2253 14.4375L14.8069 14.741V17.6285C14.8069 20.4955 14.8069 20.5201 14.7208 20.6719C14.6224 20.8441 14.3845 21 14.2163 21C14.1548 21 14.0482 20.9754 13.9702 20.9426C13.8964 20.9139 13.0884 20.3848 12.1696 19.7736L10.5003 18.6621L8.83097 19.7736C7.91222 20.3848 7.10421 20.9139 7.03039 20.9426C6.95246 20.9754 6.84582 21 6.78429 21C6.61613 21 6.37824 20.8441 6.2798 20.6719C6.19367 20.5201 6.19367 20.4955 6.19367 17.6285V14.741L5.77121 14.4375C5.00832 13.8838 4.1757 12.9773 3.6507 12.1201C2.8796 10.865 2.45304 9.22031 2.51457 7.73145C2.6048 5.64375 3.4046 3.81445 4.86066 2.3584C6.07882 1.13613 7.53078 0.393751 9.26984 0.102539C9.64308 0.0410156 10.8777 -0.0123043 11.1361 0.0246105ZM9.83996 1.27559C7.69894 1.49297 5.84503 2.66191 4.7089 4.51172C4.35617 5.09004 4.01984 5.94316 3.87628 6.62402C3.6466 7.73555 3.71632 8.99473 4.06496 10.0611C4.74992 12.1529 6.34542 13.7484 8.43722 14.4334C9.74972 14.8641 11.2509 14.8641 12.5634 14.4334C14.6552 13.7484 16.2507 12.1529 16.9357 10.0611C17.3663 8.74863 17.3663 7.24746 16.9357 5.93496C16.5911 4.88086 16.0538 4.00313 15.2745 3.22383C13.8267 1.77598 11.8538 1.07051 9.83996 1.27559ZM12.5101 15.7295C11.7636 15.9182 11.3493 15.9674 10.5003 15.9674C9.45031 15.9674 8.65871 15.8361 7.76046 15.5039L7.42414 15.3809V17.3086V19.2363L8.83507 18.2971C9.61027 17.7803 10.2993 17.3455 10.3732 17.3291C10.4429 17.3168 10.5577 17.3168 10.6275 17.3291C10.7013 17.3455 11.3903 17.7803 12.1655 18.2971L13.5765 19.2363V17.3086V15.3809L13.2361 15.5039C13.0515 15.5736 12.7234 15.6762 12.5101 15.7295Z"
              fill="white"
            />
            <path
              d="M10.7868 3.16253C10.8647 3.21175 10.9591 3.28968 10.9919 3.33479C11.0247 3.37991 11.32 3.94593 11.6481 4.58987L12.2429 5.76292L13.5882 5.95569C14.3305 6.05823 14.9909 6.16897 15.0565 6.19358C15.2206 6.26331 15.3723 6.45198 15.4052 6.62835C15.4667 6.94827 15.4093 7.0221 14.3346 8.04339C13.7809 8.56839 13.3298 9.02366 13.3298 9.04827C13.3298 9.07698 13.4323 9.67581 13.5554 10.3854C13.6948 11.1729 13.7768 11.7225 13.7604 11.8045C13.7071 12.0916 13.3585 12.3418 13.0673 12.2926C12.9975 12.2803 12.3987 11.9932 11.7384 11.6528C11.0821 11.3123 10.5202 11.0334 10.4997 11.0334C10.4792 11.0334 9.91727 11.3123 9.26102 11.6528C8.60067 11.9932 8.00184 12.2803 7.93211 12.2926C7.6409 12.3418 7.29227 12.0916 7.23895 11.8045C7.22254 11.7225 7.30457 11.1729 7.44403 10.3854C7.56707 9.67581 7.66961 9.07698 7.66961 9.04827C7.66961 9.02366 7.21844 8.56839 6.66473 8.04339C5.59012 7.0221 5.5327 6.94827 5.59422 6.62835C5.62703 6.45198 5.77879 6.26331 5.94285 6.19358C6.00848 6.16897 6.66883 6.05823 7.41121 5.95569L8.75653 5.76292L9.35125 4.58987C9.67938 3.94593 9.97469 3.37991 10.0075 3.33479C10.1059 3.20354 10.3438 3.07639 10.4997 3.07639C10.5776 3.07639 10.7089 3.11741 10.7868 3.16253ZM10.0895 5.86956C9.69988 6.65296 9.54813 6.86214 9.33895 6.91136C9.28973 6.92366 8.87137 6.98518 8.4161 7.05081C7.95672 7.11643 7.57527 7.17796 7.56707 7.18616C7.56297 7.19436 7.82957 7.45686 8.1659 7.77268C8.50223 8.0885 8.81395 8.40432 8.85906 8.47405C8.90828 8.55198 8.9411 8.67093 8.9411 8.78167C8.9411 8.93343 8.74832 10.1557 8.67449 10.492C8.65399 10.5699 8.75653 10.5289 9.4866 10.1516C10.1716 9.79886 10.3561 9.72093 10.4997 9.72093C10.6432 9.72093 10.8278 9.79886 11.5128 10.1516C12.2429 10.5289 12.3454 10.5699 12.3249 10.492C12.2511 10.1557 12.0583 8.93343 12.0583 8.78167C12.0583 8.67093 12.0911 8.55198 12.1403 8.47405C12.1854 8.40432 12.4971 8.0885 12.8335 7.77268C13.1698 7.45686 13.4364 7.19436 13.4323 7.18616C13.4241 7.17796 13.0427 7.11643 12.5833 7.05081C12.128 6.98518 11.7096 6.92366 11.6604 6.91136C11.4513 6.86214 11.2995 6.65296 10.9098 5.86956C10.6966 5.43889 10.512 5.08616 10.4997 5.08616C10.4874 5.08616 10.3028 5.43889 10.0895 5.86956Z"
              fill="white"
            />
          </svg>
          <p className="text-xxs text-white mt-1">Rewards</p>
        </button> */}
        {/* <Link to="/my-profile" className="flex flex-col items-center">
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.76101 2.03093C8.72741 2.2073 7.71022 2.76921 7.05397 3.528C5.45026 5.39421 5.5405 8.08484 7.25905 9.80339C8.97351 11.5178 11.6723 11.6081 13.5221 10.0167C14.0964 9.52449 14.6214 8.72468 14.8592 7.9946C15.5524 5.87 14.6091 3.54031 12.6403 2.51082C11.738 2.03914 10.7085 1.87097 9.76101 2.03093ZM11.0038 3.32703C12.7633 3.59773 13.9979 5.26296 13.7436 7.01433C13.3991 9.35632 10.7946 10.5868 8.78893 9.35222C7.6405 8.64675 7.02526 7.27683 7.27546 5.98074C7.61999 4.20886 9.24011 3.05632 11.0038 3.32703Z"
              fill="white"
            />
            <path
              d="M14.8181 10.5048C14.7238 10.55 14.6089 10.6484 14.5679 10.7181C14.3587 11.0668 14.4161 11.2923 14.8345 11.7435C15.7533 12.7443 16.3029 14.0158 16.389 15.3652C16.4259 15.9025 16.389 16.0091 16.0609 16.3168C14.8058 17.4898 11.1144 18.0394 8.01771 17.5103C6.6765 17.2847 5.49115 16.8295 4.96205 16.3414C4.61752 16.0173 4.5765 15.9107 4.60931 15.3898C4.69134 14.0486 5.24095 12.7443 6.13099 11.7845C6.45912 11.4236 6.53705 11.28 6.50834 11.0421C6.45912 10.6033 5.96283 10.3203 5.58549 10.5171C5.42963 10.5992 4.97845 11.075 4.68314 11.4769C3.84642 12.6048 3.36654 13.9625 3.29271 15.4021C3.2558 16.1814 3.39525 16.5875 3.89154 17.1166C5.65111 18.9869 11.0857 19.6226 14.8427 18.3921C15.8722 18.0558 16.6228 17.6293 17.1109 17.1084C17.6031 16.5875 17.7425 16.1814 17.7056 15.4021C17.6154 13.6712 16.9222 12.0306 15.7738 10.833C15.3636 10.4064 15.1585 10.3367 14.8181 10.5048Z"
              fill="white"
            />
          </svg>
          <p className="text-xxs text-white mt-1">My Profile</p>
        </Link> */}
      </footer>
    </main>
  );
};
const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isDigitalClinicPath = useMemo(
    () => pathname.startsWith("/digital-clinic"),
    [pathname]
  );

  return (
    <>
      <ScrollRestoration />
      {/* {!isDigitalClinicPath && (
        <div
          className="fixed inset-0 hidden h-screen w-screen lg:landscape:flex xs:landscape:flex sm:landscape:flex flex-col items-center justify-center bg-white"
          style={{ zIndex: "999999999" }}
        >
          <Rotate className="flex-shrink-0 h-32 w-36" />
          <p className="mt-6 w-72 text-darkgray text-xl text-center">
            Please rotate your phone to access the application.
          </p>
        </div>
      )} */}
      {children}
    </>
  );
};
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthProvider>
        <Layout />
        <Header />
      </AuthProvider>
    ),
    children: [
      { index: true, element: <DigitalHealthScreen /> },
      { path: "my-account", element: <MyAccount /> },
      { path: "tutorial", element: <Tutorial /> },
      { path: "support", element: <Support /> },
      { path: "assessments", element: <Assessments /> },
      { path: "select-assessments", element: <SelectAssessments /> },
      { path: "configure-assessments", element: <ConfigureAssessments /> },
      { path: "digital-health-screen", element: <DigitalHealthScreen /> },
      { path: "start-scan", element: <StartScan /> },
      { path: "select-scan", element: <SelectScanOption /> },
      // { path: "select-option", element: <SelectOption /> },
      { path: "all-scan-instructions", element: <AllScanInstructions /> },
        { path: "vital-scan-instructions", element: <VitalsScanInstructions /> },
      { path: "digimer-assessment", element: <DigiMerAssesment /> },
      { path: "scan-instructions", element: <ScanInstructions /> },
      { path: "camera-permission-guide", element: <CameraPermissionGuide /> },
      // { path: "select-posture", element: <SelectPosture /> },
      { path: "all-combined-result", element: <AllCombinedResult /> },
      { path: "scan-result", element: <ScanResult /> },
      {
        path: "cardiovascular-observation-result",
        element: <CardiovascularObservationResult />,
      },
      { path: "survey", element: <Survey /> },
      { path: "vouchers", element: <Vouchers /> },
      { path: "Abha-Details", element: <Abha /> },
      { path: "Lab-packages", element: <LabPackages /> },
      { path: "lab-package-detail", element: <LabPackageDetail /> },
      { path: "Doctor-list", element: <DoctorList /> },
      { path: "Doctor-appointment", element: <DoctorAppointment /> },
      { path: "Education", element: <Education /> },
      { path: "Education-details", element: <EducationDetails /> },
      { path: "Wellness-program", element: <WellnessProgram /> },
      { path: "Join-program", element: <JoinProgram /> },
      { path: "Medication", element: <Medication /> },
      { path: "Nutrition", element: <Nutrition /> },
      { path: "Activity", element: <Activity /> },
      { path: "Walking", element: <Walking /> },
      { path: "Walking-details", element: <WalkingDetails /> },
      { path: "bmi", element: <BMI /> },
      { path: "mental-wellbing", element: <MentalWellbing /> },
      { path: "Daily-wellbing", element: <DailyWellbing /> },
      { path: "Wellbing-details", element: <WellbingDetails /> },
      { path: "Health-hebits", element: <HealthHabbits /> },
      { path: "Health-details", element: <HealthDetails /> },
      { path: "Rewards", element: <Reward /> },
      { path: "Live-chat", element: <LiveChat /> },
      { path: "vitals-index", element: <VitalsIndex /> },
      { path: "heart-score", element: <HeartHealthScore /> },
      { path: "diabetes-insight", element: <DiabetesInsights /> },
      { path: "my-care", element: <MyCare /> },
      // { path: "Breath-lab", element: <BreathLab /> },
      { path: "Package-list", element: <PackageList /> },
      { path: "Package-details", element: <PackageDetails /> },
      { path: "Insurance-list", element: <InsuranceList /> },
      // { path: "Back-pain", element: <BackPain /> },
      // { path: "Period-cramps", element: <PeriodCramps /> },
      // { path: "Migraine-pain", element: <MigrainePain /> },
      { path: "score-history", element: <ScoreHistory /> },
      // { path: "Headache-pain", element: <Headache /> },
      // { path: "Shoulder-pain", element: <ShoulderPain /> },
      // { path: "Knee-pain", element: <KneePain /> },
      { path: "my-health", element: <MyHealth /> },
      { path: "score-details", element: <ScoreDetails /> },
      { path: "My-mind", element: <MyMind /> },
      { path: "discount-center", element: <DiscountCenter /> },
      { path: "bmi-history", element: <BmiHistory /> },
      { path: "vitals-score", element: <VitalsScore /> },
      { path: "health-challenge", element: <HealthChallenge /> },
      { path: "mood-insight", element: <MoodInsight /> },
      { path: "mood-history", element: <MoodHistory /> },
      { path: "better-sleep", element: <BetterSleep /> },
      { path: "content-details", element: <ContentDetails /> },
      { path: "content-tabs", element: <ContentTabs /> },
      { path: "bedtime-story", element: <BedtimeStory /> },
      { path: "bedtime-melody", element: <BedtimeMelody /> },
      { path: "relaxing-music", element: <RelaxingMusic /> },
      { path: "fitness-package", element: <FitnessPackage /> },
      { path: "nutrition-package", element: <NutritionPackage /> },
      { path: "nutrition-package-list", element: <NutritionPackageList /> },
      { path: "bedtime-stretching", element: <BedtimeStretching /> },
      { path: "wellbing", element: <Wellbeing /> },
      // { path: "self-care", element: <SelfCare /> },
      // { path: "managing-stress", element: <ManagingStress /> },
      // { path: "personal-growth", element: <PersonalGrowth /> },
      // { path: "increasing-work", element: <IncreasingWorkLife /> },
      // { path: "emotional-resilience", element: <EmotionalResilience /> },
      { path: "mindful-moments", element: <MindfulMoments /> },
      { path: "relaxation-music", element: <RelaxationMusic /> },
      { path: "yoga-meditation", element: <YogaMeditation /> },
      { path: "visualization", element: <VisualizationTranquility /> },
      { path: "wellbeing-detail", element: <WellbeingContentDetails /> },
      { path: "our-pricing", element: <OurPricing /> },
      { path: "mood-step", element: <MoodtrackStep /> },
      { path: "insurance-policy", element: <InsurancePolicy /> },
      { path: "relive-pain", element: <RelivePain /> },
      { path: "nutration-list", element: <NutrationList /> },
      { path: "nutration-recipes-list", element: <NutritionReceipesList /> },
      { path: "nutration-recipe-detail", element: <NutritinReceipeDetail /> },
      { path: "do-you-know", element: <DYKList /> },
      { path: "dyk-detail", element: <DYKDetails /> },
      { path: "configure-alerts", element: <ConfigureAlerts /> },
      { path: "alert-select-user", element: <SelectUserAlert /> },
      { path: "alert-setting", element: <AlertSetting /> },
      { path: "diagnostic-packages", element: <DiagnosticPackages /> },
      { path: "doctor-consultation", element: <DoctorConsultation /> },
      { path: "goal", element: <Goal /> },
      { path: "add-goal", element: <AddGoal /> },
      { path: "selected-goal", element: <SelectedGoal /> },
      { path: "cognitive-score", element: <CognitiveScore /> },
      { path: "cognitive-assessment", element: <CognitiveAssessments /> },
      { path: "simon-test", element: <SimonTest /> },
      { path: "simon-circle", element: <SimonTestCircle /> },
      { path: "simon-score", element: <SimonScore /> },
      { path: "nutrition-results", element: <NutritionResults /> },
      { path: "water-tracker", element: <WaterTracker /> },
      { path: "nutrition-history", element: <NutrationHistory /> },
      { path: "unity-score", element: <UnityScore /> },
      { path: "allergy-dashboard", element: <AllergyDashboard /> },
      { path: "new-assessment", element: <NewAssessment /> },
      { path: "assessment-result", element: <AssessmentResult /> },
      { path: "pulmo-dashboard", element: <PulmoDashboard /> },
      { path: "all-scan-dashboard", element: <AllScanDashboard /> },
      { path: "fingerscan-instruction", element: <FingerScanInstructions /> },
      {
        path: "pulmo-fingerscan-instruction",
        element: <PulmoFingerScanInstruction />,
      },
      {
        path: "pulmo-facescan-instruction",
        element: <PulmoFaceScanInstruction />,
      },
      {
        path: "upload-document",
        element: <UploadDocuments />,
      },

      { path: "voice-audio-sample", element: <VoiceAudiSample /> },
      { path: "cough-audio-sample", element: <CoughAudiSample /> },
      { path: "pulmo-survey", element: <PulmoSurvey /> },
      { path: "pulmo-result", element: <PulmonaryResult /> },
      { path: "pulmonary-observation-result", element: <PulmonaryResult /> },
      { path: "vision-instructions", element: <VisionInstructions /> },
      { path: "vision-result", element: <VisionResult /> },
      { path: "vision-survey", element: <VisionSurvey /> },
      { path: "derma-start", element: <DermaStart /> },
      { path: "skin-analyzer", element: <SkinAnalyzer /> },
      { path: "derma-result", element: <DermaResult /> },
      { path: "vitals-derma", element: <VitalsDerma /> },
      { path: "dental-start", element: <DentalStart /> },
      { path: "capture-type", element: <CaptureType /> },
      { path: "dental-analyzer", element: <DentalAnalyzer /> },
      { path: "assistant-instructions", element: <AssistantInstructions /> },
      { path: "dental-result", element: <DentalScanResult /> },
      { path: "dental-report", element: <DentalScanHistory /> },
      { path: "bmi-start", element: <EventGetStarted /> },
      { path: "bmi-photo-capture", element: <BMIPhotoCapture /> },
      { path: "bmi-result-edit", element: <BMIResultEdit /> },
      {
        path: "history",
        children: [
          { index: true, element: <DetailHistory /> },
          { path: "heart-health", element: <HeartHealth /> },
          { path: "body-vitals", element: <BodyVitals /> },
          { path: "physio-fitness", element: <PhysioFitness /> },
          { path: "stress-index", element: <StressIndex /> },
        ],
      },
    ],
  },
  {
    path: "mood-tracking",
    element: (
      <AuthProvider>
        <Layout />
        <MoodTracking />
      </AuthProvider>
    ),
  },
  {
    path: "select-user",
    element: (
      <AuthProvider>
        <Layout />
        <SelectUser />
      </AuthProvider>
    ),
  },
  {
    path: "request-callback",
    element: (
      <AuthProvider>
        <Layout />
        <RequestCallback />
      </AuthProvider>
    ),
  },
  {
    path: "my-profile",
    element: (
      <AuthProvider>
        <Layout />
        <MyProfile />
      </AuthProvider>
    ),
  },
  // { path: "Analysis-Data", element: <AnalysisData /> },
  // { path: "creating-program", element: <ProgramTracking /> },
  // { path: "traking-success", element: <TrakingSuccess /> },
  // { path: "terms-of-use", element: <TermsOfUSe /> },
  // { path: "privacy-policy", element: <PrivacyPolicy /> },
  {
    path: "terms-of-use",
    element: (
      <Layout>
        <TermsOfUSe />
      </Layout>
    ),
  },
  {
    path: "privacy-policy",
    element: (
      <Layout>
        <PrivacyPolicy />
      </Layout>
    ),
  },
  {
    path: "all-combined-face-scan",
    element: (
      <AuthProvider>
        <Layout />
        <AllCombinedFaceScan />
      </AuthProvider>
    ),
  },
  {
    path: "vitals-derma-face-scan",
    element: (
      <AuthProvider>
        <Layout />
        <VitalsDermaFaceScan />
      </AuthProvider>
    ),
  },
  {
    path: "face-scan",
    element: (
      <AuthProvider>
        <Layout />
        <FaceScan />
      </AuthProvider>
    ),
  },
  {
    path: "pulmo-finger-scan",
    element: (
      <AuthProvider>
        <Layout />
        <PulmoFingerScan />
      </AuthProvider>
    ),
  },
  {
    path: "pulmo-face-scan",
    element: (
      <AuthProvider>
        <Layout>
          <PulmoFaceScan />
        </Layout>
      </AuthProvider>
    ),
  },
  {
    path: "vision-facescan",
    element: (
      <AuthProvider>
        <Layout />
        <VisionFaceScan />
      </AuthProvider>
    ),
  },
  {
    path: "finger-scan",
    element: (
      <AuthProvider>
        <Layout />
        <FingerScan />
      </AuthProvider>
    ),
  },
  {
    path: "digital-clinic",
    element: (
      <AuthProvider>
        <DigitalClinic />
      </AuthProvider>
    ),
    errorElement: <NotFound />,
  },
  {
    path: "basic-details",
    element: (
      <AuthProvider>
        <Layout />
        <BasicDetails />
      </AuthProvider>
    ),
  },
  {
    path: "/login",
    element: (
      <AuthProvider>
        <Layout />
        <Login />
      </AuthProvider>
    ),
  },
  {
    path: "referal",
    element: (
      <AuthProvider>
        <Layout />
        <Referal />
      </AuthProvider>
    ),
  },
  { path: "download", element: <DownloadAPP /> },
  // { path: "*", element: <NotFound /> },
  {
    path: "*",
    element: (
      <Layout>
        <NotFound />
      </Layout>
    ),
  },
]);

const App = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return <RouterProvider router={router} />;
};

export default App;
